export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "thrusterCalculate.worker.97503c7e5b07a1118435-880.worker.js");
}
